<template>
  <div class="mx-5 mb-5">

    <div class="row">
      <div class="col-md-4">
        <CompanyNew :company="currentCompany" @saveCompany="saveCompany($event)"
                    :thereIsParentCompany="companies.length > 0"
                    save-button="Adicionar"/>
      </div>

      <div class="col-md-8">

        <div class="ibox" style="height: 100%">
          <div class="ibox-title">
            Empresas Cadastradas
          </div>

          <div class="ibox-content">

            <div class="info" v-if="companies.length === 0">

              <p>Você não cadastrou nenhum estabelecimento.
                Informe pelo menos uma matriz para continuar
              </p>
            </div>

            <table v-else class="table table-borderless table-border table-align">
              <thead>
              <tr>
                <th>Razão Social</th>
                <th>CNPJ</th>
                <th>I.E.</th>
                <th>UF</th>
                <th>Tipo</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="company in companies" :key="company.id">
                <td>{{ company.name }}</td>
                <td> {{ company.cnpj | cnpj }}</td>
                <td>{{ company.ie }}</td>
                <td>{{ company.uf }}</td>
                <td>{{ company.type === 'parent' ? 'Matriz' : 'Filial' }}</td>
                <td>
                  <button @click="sendDeleteCompany(company)" class="btn btn-outline-red float-right mr-2">
                    <Trash2Icon/>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />

          </div>

        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-md-3 mx-auto text-center mt-5">
        <button @click="$emit('nextStep')" :disabled="enableNextButton" class="btn btn-block btn-primary ">
          Próximo Passo
        </button>
      </div>
    </div>

    <Modal v-if="companyToDelete" v-model="showModal" class="modal-delete-company">
      <h3 slot="header">Excluir empresa</h3>
      <div class="row">
        <div class="col-md-12 text-center">
          <h4>
            <p>
              <strong v-if="companyToDelete.type === 'parent'">
                Você tem certeza de que deseja excluir a matriz {{ companyToDelete.name }}? Todas as filiais criadas também serão removidas.
              </strong>

              <strong v-else>
                Você tem certeza de que deseja excluir a filial {{ companyToDelete.name }}?
              </strong>
            </p>
          </h4>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12 text-center">
          <button @click="showModal = false" class="btn btn-outline px-3 mr-1">Agora não</button>
          <button @click="deleteCompany()" class="btn btn-outline-red px-3">Excluir</button>
        </div>
      </div>

    </Modal>

  </div>
</template>

<script>
  import CompanyNew from '@/components/wizard/FormWizard'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { Trash2Icon } from 'vue-feather-icons'
  import Modal from '@/components/shares/specialTag/Modal'

  export default {
    components: { CompanyNew, Modal, Pagination, Trash2Icon },
    computed: {
      companies() {
        return this.getModels || []
      },
      enableNextButton() {
        return this.companies.length === 0
      },
    },
    created() {
      this.find()
    },
    data() {
      return {
        companyToDelete: null,
        currentCompany: { cityCode: '3550308', uf: 'SP' },
        nameModel: 'company',
        rootPath: 'companies',
        showModal: false
      }
    },
    methods: {
      deleteCompany() {
        this.asyncTemplateDelete(this.companyToDelete, {
          after: () => {
            this.find()
            this.showModal = false
            this.companyToDelete = null
            this.$notify.add('Empresa excluída com sucesso!')
          }
        })
      },
      find() {
        this.order.cnpj = 'asc'
        this.asyncTemplateSelect()
      },
      saveCompany(company) {
        this.asyncTemplateSave(company, {
          after: () => {
            this.currentCompany = { cityCode: '3550308', uf: 'SP' }
            this.find()
          }
        })
      },
      sendDeleteCompany(company) {
        this.companyToDelete = company
        this.showModal = true
      }
    },
    mixins: [ModelMapper],
    name: 'Companies',
    props: {
      account: { required: true, type: Object }
    }
  }
</script>

<style scoped>

  .info {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info > p {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #051B30;
    width: 376px;
  }

  .modal-delete-company p {
    color: black;
    margin: 0;
  }

</style>
